exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".detail-row td[data-v-7494198c]{height:55px}", "", {"version":3,"sources":["/app/src/components/master/buyingTariff/Surcharge.vue"],"names":[],"mappings":"AACA,gCACE,WAAa,CACd","file":"Surcharge.vue","sourcesContent":["\n.detail-row td[data-v-7494198c] {\n  height: 55px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7494198c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/master/buyingTariff/Surcharge.vue
// module id = 961
// module chunks = 11